import React from 'react';
import './App.css';
import Csvfilereader from './Csvfilereader';
import Header from './Header';

function App() {
  return (
    <div className="App">
      <Header/>
      <Csvfilereader/>
  
    </div>
  );
}

export default App;
